import React from 'react';
import {
    OptionShimmer,
    TitleShimmer,
    DescriptionShimmer,
    WrapperShimmer,
    Shimmer
} from './styled';

export const ListMyPackageShimmer: React.FC = () => (
    <WrapperShimmer>
        <OptionShimmer>
            <TitleShimmer><Shimmer /></TitleShimmer>
            <DescriptionShimmer><Shimmer /></DescriptionShimmer>
        </OptionShimmer>
        <OptionShimmer>
            <DescriptionShimmer><Shimmer /></DescriptionShimmer>
        </OptionShimmer>
    </WrapperShimmer>
);